// InfoDot.js — UYARI AÇIKLAMA NOKTASI ⓘ (4 Eyl 2026'da kendi dosyasına çıktı)
//
// 🔑 Serkan (3 Eyl): *"Popup bir ekran çıksın, yanına i koyalım görelim."* ·
//    *"Hatta bu i bütün uyarılar için kullanılabilir, basit ve anlaşılır."* ·
//    *"Hatta içinde düzeltici eylemi de söyleyebiliriz."*
//
// 🔴 NEDEN TAŞINDI (4 Eyl): FCL Limits barındaki ⓘ'ler TIKLANMIYORDU — orada
//    yalnız `title` ipucu vardı, çünkü bileşen FTLPanel'in içine gömülüydü ve
//    başka dosyadan kullanılamıyordu. Serkan: *"Burdaki i remarklarını
//    tıklıyorum hiçbir şey çıkmıyor."*  İkinci bir kopya yazmak iki ⓘ'nin
//    zamanla ayrışması demekti; bileşen dışarı alındı.
//
// Stiller CSS değişkenlerinden okunur (panelin `S`/`C` sözlüklerine bağlı
// DEĞİL) — böylece hangi ekrandan çağrılırsa çağrılsın aynı görünür.
import React, { useState } from 'react';
import { vw } from '../yaziBoyutu';
import { usePencereKapat, KapatX } from './pencereKapat';

const V = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)', border2:'var(--border2)',
  accent:'var(--accent)', amber:'var(--amber)', t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};
const S = {
  nokta:{ marginLeft:5, cursor:'pointer', fontSize:11, fontWeight:700, color:V.accent,
          border:`1px solid ${V.accent}`, borderRadius:'50%', width:15, height:15,
          display:'inline-flex', alignItems:'center', justifyContent:'center',
          lineHeight:1, fontFamily:'var(--mono)' },
  ortu:{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex',
         alignItems:'center', justifyContent:'center', zIndex:80 },
  kart:{ background:V.bg2, border:`1px solid ${V.border}`, borderRadius:10,
         width:520, maxWidth:vw(92) },
  basSatir:{ padding:'10px 16px', borderBottom:`1px solid ${V.border}`, background:V.bg3 },
  bas:{ fontSize:11, fontWeight:700, letterSpacing:1.5, color:V.accent,
        fontFamily:'var(--mono)', textTransform:'uppercase' },
  etiket:{ fontSize:10, color:V.t3, fontFamily:'var(--mono)', letterSpacing:1,
           textTransform:'uppercase', display:'block', marginBottom:6 },
  kutu:(renk) => ({ padding:'9px 12px', background:V.bg3, borderLeft:`2px solid ${renk}`,
                    fontSize:12, color:V.t2, whiteSpace:'normal', lineHeight:1.8 }),
  kapat:{ background:'none', border:`1px solid ${V.border2}`, color:V.t2, fontSize:10,
          letterSpacing:1, fontFamily:'var(--mono)', padding:'5px 14px', cursor:'pointer',
          borderRadius:4 },
};

/**
 * Üç parça: ① ne oldu ② kuralın kendisi ③ ne yapmalı.
 * `note` yoksa hiç çizilmez — boş pencere teklif etmeyiz.
 */
// `madde` — TALİMATIN KENDİ CÜMLESİ (19 Eyl 2026).
// 🔑 Serkan: *"tıklayınca açılsın, SHT talimat numarası ve metni çıksın."*
// 🔑 `rule` BİZİM açıklamamızdır (İngilizce, yorum); `madde` KAYNAĞIN
//    kendisidir (Türkçe, kırpılmamış). İkisi bilerek ayrı kutuda: denetimde
//    *"bu metin nereden geldi"* sorusunun cevabı ikincisidir. RULE SET ekranı
//    3 Eyl'den beri aynı deseni kullanıyor (`maddeMetni` + `shtArticles.js`).
//    Karıştırsaydık, bizim cümlemiz talimatın cümlesi gibi okunurdu.
// `maddeKaynak` (29 Eyl 2026): metin hangi mevzuattan — SHT-FTL/HG · SHT-FCL ·
// SHT-MED. Eskiden başlık sabit "SHT-FTL/HG" diyordu; FCL/MED maddesinde yalan olurdu.
export default function InfoDot({ note, rule, action, madde, maddeRef, maddeKaynak = 'SHT-FTL/HG',
                                  title = 'WHY IS THIS FLAGGED?',
                                  testid = 'match-review-info' }) {
  const [open, setOpen] = useState(false);
  // 12 Eki 2026: ESC + sağ üst ✕ (pencereKapat.js). ⓘ çoğu zaman başka bir pencerenin İÇİNDE açılır (EDIT DUTY,
  // ASSIGN kartı) — ESC yalnız bu kartı kapatır, alttaki pencere açık kalır.
  usePencereKapat(() => setOpen(false), open && !!note);
  if (!note) return null;
  return (
    <>
      <span role="button" tabIndex={0} data-testid={testid} title="Why is this flagged?"
            onClick={e => { e.stopPropagation(); setOpen(true); }}
            onKeyDown={e => { if (e.key === 'Enter') { e.stopPropagation(); setOpen(true); } }}
            style={S.nokta}>i</span>
      {open && (
        <div onClick={e => { e.stopPropagation(); setOpen(false); }} style={S.ortu}>
          <div onClick={e => e.stopPropagation()} style={S.kart}>
            <div style={{ ...S.basSatir, display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
              <span style={S.bas}>{title}</span>
              <KapatX onClose={() => setOpen(false)} testid={`${testid}-x`} />
            </div>
            <div style={{ padding:16 }}>
              <span style={S.etiket}>What happened</span>
              <div style={S.kutu(V.amber)}>{note}</div>
              {rule && (<>
                <span style={{ ...S.etiket, marginTop:12 }}>The rule behind it</span>
                <div style={S.kutu(V.border2)}>{rule}</div>
              </>)}
              {action && (<>
                <span style={{ ...S.etiket, marginTop:12 }}>What to do</span>
                <div style={S.kutu(V.accent)}>{action}</div>
              </>)}
              {madde && (<>
                <span style={{ ...S.etiket, marginTop:12 }}>
                  The article itself{maddeRef ? ` — ${maddeRef}` : ''} ({maddeKaynak}, original text)
                </span>
                {/* Metin TÜRKÇE kalır: kaynak odur. Arayüz İngilizce, madde
                    değil. `whiteSpace:'pre-wrap'` madde fıkralarını korur. */}
                <div style={{ ...S.kutu(V.border2), whiteSpace:'pre-wrap',
                              maxHeight:220, overflowY:'auto' }}
                     data-testid="infodot-madde">{madde}</div>
              </>)}
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:14 }}>
                <button style={S.kapat} onClick={() => setOpen(false)}>CLOSE</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
